export default {"src":"/_next/static/image/public/images/flags/flag_239.7197e20f6e8fc3d264b683ba50f42717.svg","height":16,"width":24};